import React, { useState, useEffect, useRef } from 'react'
import PropTypes from 'prop-types';
import { optionChecker, fieldsetRoot, fieldGroup, fieldLabel, fieldSpan, fieldsetInput, clearBtn, iconRoot} from './optionschecker.module.scss'

const labelStyle = {
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between'
}
 
function OptionsChecker({
  title, 
  options, 
  handleChange,
  facets = null,
}){

  const itemsRef = useRef([])
  const [showClearBtn, setShowClearBtn] = useState(false)

  useEffect(() => {
    itemsRef.current = itemsRef.current.slice(0, options.length);
 }, [options]);

  useEffect(() => {
    let tempShowClearBtn = false
    for(let i = 0; i < options.length; i++){
      if(options[i]?.checked){
        tempShowClearBtn = true
        break;
      }
    }
    setShowClearBtn(tempShowClearBtn)
  }, [options])


  return (
    <div className={optionChecker}>
      <fieldset className={fieldsetRoot}> 
            <legend style={labelStyle}>
                {title} 
                {showClearBtn && 
                    <button 
                        type="button" 
                        onClick={(e) => {handleChange(facets, e.target.name, e.target.checked, true)}} 
                        className={clearBtn}>
                            clear
                    </button> 
                  }
            </legend>
            <div className={fieldGroup}>
                {options && options.length > 0 && options.map((option, i) =>
                  <label 
                    key={option.label} 
                    htmlFor={`checkbox-${option.label}`} 
                    className={fieldLabel}
                  >
                        <input 
                            className={fieldsetInput}
                            id={option.label} 
                            name={option.name} 
                            ref={el => {itemsRef.current[i] = el}}
                            type="checkbox" 
                            checked={option.checked}
                            onChange={(e) => {handleChange(facets, e.target.name, e.target.checked, false)}}
                            data-indeterminate="false" 
                            value=""
                        />


                        {option.checked ?
                              <svg 
                                className={iconRoot} 
                                style={{ width: '24px'}} 
                                focusable="false" 
                                viewBox="0 0 24 24" 
                                aria-hidden="true"
                              >
                                  <path 
                                    d="M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
                                  />
                              </svg> 
                          :
                            <svg 
                              focusable="false" 
                              viewBox="0 0 24 24" 
                              aria-hidden="true"
                              style={{width: '24px', fill: 'var(--color-text-2' }}
                            >
                                <path d="M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"/>
                            </svg>
                        } 
                      <span className={fieldSpan} style={{ pointerEvents: "auto" }}>
                          {option.label}
                      </span>
                  </label>

                )}
            </div>
      </fieldset>
    </div>
  )
}

OptionsChecker.propTypes = {
  title: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  handleChange: PropTypes.func.isRequired,
  facets: PropTypes.string,
}
export default OptionsChecker
